<template>
  <div class="group-buy-team-list-component">
    <ul class="team-list"
        v-if="list.length > 0"
    >
      <li class="team-item-container"
          v-for="item in list"
          :key="item.id"
      >
        <list-item :id="item.id"
                   :leader="item.leader"
                   :remain="item.remainMember"
                   :start="startTime"
                   :end="item.endedTime"
                   :groupBuyUrl="item.H5Url"
        />
      </li>
    </ul>
    <div class="empty"
         v-else
    >
      呼朋唤友，
      <router-link class="link"
                   :to="{ name: 'GroupBuyCreate', params: { id } }"
      >
        马上开团 >
      </router-link>
    </div>
  </div>
</template>

<script>
  import ListItem from '@/pages/GroupBuy/components/BlockTeamListItem';

  export default {
    name: 'GroupBuyBlockTeamList',
    components: {
      ListItem,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      list: {
        type: Array,
        required: true,
      },
      startTime: {
        type: Number,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .team-list {
    margin: 0;
    padding: 0 @size-base;
    list-style: none;
    max-height: 670px;
    overflow: scroll;
  }

  .team-item-container {
    padding: @size-small 0;

    &:not(:last-child) {
      position: relative;

      &:after {
        content: '';
        height: 1px;
        position: absolute;
        right: 130px;
        bottom: 0;
        left: 0;
        background: @background-color-base;
      }
    }
  }

  .link {
    color: @color-text-primary;
  }
</style>
